class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      // SVNTY (2026-09-19): 250ms, not Trade's 300 — the sheet is judged on an
      // iPhone on Egyptian mobile data, where the extra 50ms reads as lag, and the
      // request that the shorter window costs is aborted in flight by
      // predictive-search.js rather than left racing its successor.
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 250).bind(this)
      );
    }
  }

  toggleResetButton() {
    // SVNTY (2026-09-19, SR-2): THE RESET BUTTON IS OPTIONAL. Trade's version dereferences
    // `this.resetButton` on every keystroke, so a search form whose CLEAR is a real link — which
    // is what the results page needs, because a `type="reset"` there empties the field and leaves
    // the 68 results and the count on screen — threw a TypeError inside the debounced input
    // handler and killed the typeahead on that form. One guard, and both shapes work.
    if (!this.resetButton) return;
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
